module.exports = __webpack_public_path__ + "img/logo-valo-motion.6d86aab5.png";